import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { Meta, UserInfo, getLocalizedLabel, valueNotEmpty, valuePathPrefix, valueIsIntNumber, getmeta, featureValueTypes, methodNames } from '../../common'
import { Container, Segment, Tab, Grid, Dropdown as PureDropdown, Checkbox as PureCheckbox, DropdownItemProps, Menu, Label, Header } from 'semantic-ui-react'
import Checkbox from '../form/Checkbox'
import {ConfigEditorUiSearchCompProps} from './CEUiSearch'
import { setFieldValue } from '../form/FormikHelpers'
import Dropdown from '../form/Dropdown'
import Input from '../form/Input'

class ConfigEditorUiSearchCompNameQuery extends Component<ConfigEditorUiSearchCompProps> {

    render() {
        const { meta, editing, locale, t, i18n, params, formik, formikprefix } = this.props
        const lang = i18n.language

        if (!(meta && meta.cats && meta.cats['feature'])) return null

        if (params.options === undefined) {
            setFieldValue(formik, formikprefix+'.options', [], false)
            return null
        }

        const defaultFmeta = getmeta(meta, 'feature', params.defaults?.type)
        const defaultMethods = defaultFmeta && defaultFmeta.params ? featureValueTypes[String(defaultFmeta.params.value_type)].methods : ['exact', 'defined']
        const defaultMethodOptions = defaultMethods.map(m => {return {key: m, value: m, text: t(methodNames[m].label)}})

        return (
            <>
            <Grid.Row>
                <Grid.Column width={2}>
                    <div className="">{t('Methods')}</div>
                </Grid.Column>
                <Grid.Column width={9}>
                    <Checkbox name={formikprefix+".method"} label={t('fulltext')} value="fulltext" fieldProps={{className: "compactfield inlineblock"}} inputProps={{disabled: !editing}}/>
                    <Checkbox name={formikprefix+".method"} label={t('exactly')} value="exact" fieldProps={{className: "compactfield inlineblock"}} inputProps={{disabled: !editing}}/>
                    <Checkbox name={formikprefix+".method"} label={t('starts')} value="prefix" fieldProps={{className: "compactfield inlineblock"}} inputProps={{disabled: !editing}}/>
                    <Checkbox name={formikprefix+".method"} label={t('reg.exp.')} value="regexp" fieldProps={{className: "compactfield inlineblock"}} inputProps={{disabled: !editing}}/>
                </Grid.Column>
                <Grid.Column width={2}>
                    <Checkbox name={formikprefix+".ci"} label={t('A=a')} fieldProps={{className: "compactfield"}} inputProps={{disabled: !editing}}/>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={4}><div className="label">{t('Defaults')}</div></Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={2}>
                    <div className="pad">{t('Value')}</div>
                </Grid.Column>
                <Grid.Column width={4}>
                    <Input name={formikprefix+".defaults.value"} inputProps={{disabled: !editing, placeholder: t('undefined')}}/>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={2}>
                    <div className="pad">{t('Method')}</div>
                </Grid.Column>
                <Grid.Column width={4}>
                    <Dropdown name={formikprefix+".defaults.method"} inputProps={{disabled: !editing}} 
                        options={defaultMethodOptions}/>
                </Grid.Column>
                <Grid.Column width={4}>
                    <Checkbox name={formikprefix+".defaults.neg"} label={t('NOT')} fieldProps={{className: "compactfield"}} 
                        inputProps={{disabled: !editing}}/>
                    <Checkbox name={formikprefix+".defaults.ci"} label={t('A=a')} fieldProps={{className: "compactfield"}} 
                        inputProps={{disabled: (!editing /*|| !fvalueType.ci*/)}}/>
                </Grid.Column>
            </Grid.Row>
            </>
        )
    }
}

export default withTranslation()(ConfigEditorUiSearchCompNameQuery)